import { useI18n } from '@i18n/useI18n';
import { AnimationContainer, Content, LottieContent, NewJar, PointsContainer } from './ProfileCoins.styled';
import Lottie from 'react-lottie-player';
import Coins from 'src/lotties/coins.json';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { CardFocusTitle, GridCard } from '@components/GridCards/Common.styled';
import db from '@utils/db';
import RainbowLoader from '@components/Loaders/RainbowLoader';


import Jar0_Icon from "@assets/svg/points/jar_0.svg";
import Jar1_Icon from "@assets/svg/points/jar_1.svg";
import Jar2_Icon from "@assets/svg/points/jar_2.svg";
import Jar3_Icon from "@assets/svg/points/jar_3.svg";
import Jar4_Icon from "@assets/svg/points/jar_4.svg";
import Jar5_Icon from "@assets/svg/points/jar_5.svg";
import Jar6_Icon from "@assets/svg/points/jar_6.svg";
import Jar7_Icon from "@assets/svg/points/jar_7.svg";
import { Jar0, Jar1, Jar2, Jar3, Jar4, Jar5, Jar6, Jar7 } from '@models/JarAnimation';
import CardInfo from '@components/GridCards/CardInfo';
import NumberRoll from './NumberRoll';
import { useStore } from '@store/appStore';
import useOnScreen from '@components/Utils/useOnScreen';


const LottieCoins = {
  loop: true,
  autoplay: false,
  animationData: Coins,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid',
  },
  isClickToPauseDisabled: true,
};

interface IProps {
  studentId?: string;
  admin?: boolean;
  updateTime?: any;
  guar?: boolean
}

export const ProfileCoins = forwardRef((props: IProps, ref) => {
  const { filterDate, settings, rewardQRScreen } = useStore();
  const i18n = useI18n();
  const [animation, setAnimation] = useState(true)
  const [coins, setCoins] = useState(null)
  const coinsRunning = useRef(false)
  const [newJar, setNewJar] = useState({ jar: null, size: null })
  const [showNew, setShowNew] = useState(null)
  const levelRef = useRef(0)
  const [isDemo, setIsDemo] = useState(false)
  const demoRunning = useRef(false)
  const animationStop = useRef(false)
  const ref2 = useRef<HTMLDivElement>(null);
  const isVisible = useOnScreen(ref2);
  const loadingData = useRef(false)
  const [loading, setLoading] = useState(false)

  useImperativeHandle(ref, () => ({
    update() {
      GetData(true)
    },
  }));

  useEffect(() => {
    if (isVisible && !loadingData.current) {
      GetData()
    }
  }, [isVisible, props.studentId, props.updateTime, rewardQRScreen])

  const GetData = async (load?) => {
    if (!load) {
      setLoading(true)
      loadingData.current = true
    }

    let data = await db.Student_Stat_GetCoins(props.studentId, props.admin ? props.admin : false)
    if (!data) {
      // No answer (e.g. the connection dropped) - keep what's shown.
      setLoading(false)
      loadingData.current = false
      return
    }
    if (props.admin) {
      let c = { coins: 0, coinsRemove: 0, coinsNew: 0 }
      c.coins = data[0]?.newcoins + data[0]?.oldcoins
      c.coinsRemove = 0;
      let l = FindLevel(c.coins)
      levelRef.current = l
      setCoins(c)
    }
    else {
      let c = { coins: 0, coinsRemove: 0, coinsNew: 0 }
      c.coins = data[0]?.oldcoins
      c.coinsNew = data[0]?.newcoins
      c.coinsRemove = Math.floor(c.coinsNew / 10);
      let l = FindLevel(data[0]?.oldcoins)
      levelRef.current = l
      setCoins({ ...c })
      if (c.coinsNew > 0) Start()
    }
    setLoading(false)
    loadingData.current = false
  }

  useEffect(() => {
    //if (coins?.coinsNew > 0 && !coinsRunning.current)animateCoins()
  }, [coins]);

  const animateCoins = () => {
    coinsRunning.current = true
    if (coins.coinsNew > 0) {
      setTimeout(() => {
        setCoins(c => {
          if (c.coinsNew > 0) {
            c.coins = c.coins + c.coinsRemove;
            c.coinsNew = c.coinsNew - c.coinsRemove;
            if (c.coinsNew < c.coinsRemove) {
              c.coins = c.coins + c.coinsNew
              c.coinsNew = 0;
            }
          }
          if (c.coinsNew > 0) animateCoins()
          else Stop()
          return { ...c }
        })
      }, 500)
    }
  }

  const Start = () => {
    setAnimation(true)
    setTimeout(() => {
      setAnimation(false)
    }, 300);
  };
  const Stop = () => {
    setTimeout(() => {
      setAnimation(false)
      setTimeout(() => {
        animationStop.current = true
        setCoins((c) => {
          let tl = FindLevel(c.coins + c.coinsNew)

          if (tl !== levelRef.current) {
            SelectJar(tl)
          }
          demoRunning.current = false
          return c
        })
      }, 420);
    }, 10);
  };

  const FindLevel = (coin) => {
    if (coin === 0) {
      return 0
    } else if (coin >= 1 && coin < 200) {
      return 1
    } else if (coin >= 200 && coin < 500) {
      return 2
    } else if (coin >= 500 && coin < 1000) {
      return 3
    } else if (coin >= 1000 && coin < 2500) {
      return 4
    } else if (coin >= 2500 && coin < 5000) {
      return 5
    } else if (coin >= 5000 && coin < 10000) {
      return 6
    } else if (coin >= 10000) {
      return 7
    }
  };

  const SelectJar = (level) => {
    setShowNew(false)
    if (level === 0) {
      setNewJar({ jar: <Jar0_Icon />, size: 0 })
    } else if (level === 1) {
      setNewJar({ jar: <Jar1_Icon />, size: 0 })
    } else if (level === 2) {
      setNewJar({ jar: <Jar2_Icon />, size: 0 })
    } else if (level === 3) {
      setNewJar({ jar: <Jar3_Icon />, size: 0 })
    } else if (level === 4) {
      setNewJar({ jar: <Jar4_Icon />, size: 0 })
    } else if (level === 5) {
      setNewJar({ jar: <Jar5_Icon />, size: 1 })
    } else if (level === 6) {
      setNewJar({ jar: <Jar6_Icon />, size: 1 })
    } else if (level === 7) {
      setNewJar({ jar: <Jar7_Icon />, size: 2 })
    }

    setTimeout(() => {
      levelRef.current = level
      setShowNew(true)
    }, 600)
  };

  const triggerDemo = () => {
    if (!demoRunning.current) {
      demoRunning.current = true
      let c = JSON.parse(JSON.stringify(coins))
      if (c.coinsNew > 0) c.coins = c.coins + c.coinsNew
      c.coinsNew = 1000;
      setCoins({ ...c })
      setIsDemo(true)
      setShowNew(false)
      animationStop.current = false
      setNewJar({ jar: null, size: null })
      Start()
    }
  }

  let a = levelRef.current === 7 ? Jar7 : levelRef.current === 6 ? Jar6 : levelRef.current === 5 ? Jar5 : levelRef.current === 4 ? Jar4 : levelRef.current === 3 ? Jar3 : levelRef.current === 2 ? Jar2 : levelRef.current === 1 ? Jar1 : Jar0

  return (
    <GridCard ref={ref2} style={props.guar ? { order: "999" } : null}>
      {coins && !loading ? <Content>
        <CardFocusTitle onClick={() => triggerDemo()}>{i18n.t('Attender Coins')}</CardFocusTitle>
        <CardInfo text='info-text-coins' />

        <AnimationContainer>
          <LottieContent show={showNew}>
            <Lottie
              onEnterFrame={(a) => {
                if (animationStop.current) {
                  let cTime = Math.floor(a.currentTime)
                  if (cTime === 16 || cTime === 32 || cTime === 48 || cTime === 80) setAnimation(true)
                }
              }}
              {...a} play={!animation} style={{width:'100%',height:'100%',overflow:'hidden',margin:'0 auto'}} />
          </LottieContent>
          <NewJar show={showNew} size={newJar.size}>
            {newJar.jar}
          </NewJar>
        </AnimationContainer>
        <PointsContainer>
          <NumberRoll isDemo={isDemo} isAdmin={props.admin} number={coins.coins} newNumber={coins.coinsNew} stop={() => Stop()} countDown={true} />
        </PointsContainer>
        <NumberRoll isDemo={isDemo} isAdmin={props.admin} number={coins.coins} newNumber={coins.coins + coins.coinsNew} stop={() => Stop()} />
      </Content> : <RainbowLoader />}
    </GridCard>
  );
});

export default ProfileCoins;


